export const raw_boiler_models = BOILER_MODELS_DICT ??
    //@ts-ignore
    global.BOILER_MODELS_DICT;
// console.log('BOILER_MODELS_DICT', BOILER_MODELS_DICT);
